import { Component } from '@angular/core';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import  *  as  helpData  from  '../../data/help/advancedSearch.json';
import { LocalStorage, LocalStorageService } from 'ngx-store';

//Model
import {  Url } from '../../model/users.model';

//Service
import { DataService } from '../../services/data.service';

@Component({
  selector: 'app-advanced',
  templateUrl: './advanced.component.html',
  styleUrls: ['./advanced.component.scss']
})
export class AdvancedComponent {
  @LocalStorage() url: Url;

    entries: any;
    p: any;
    help: any;
    loadingIndicator: boolean = true;
    spinner: boolean = false;

    result;
    errorFromSubscribe;
    errorFromCatch;
    displayItems;
    upURL;

    private role_id : any;
    private components : any;

  constructor(private http: HttpClient, private data: DataService, private svc_storage :LocalStorageService) { }

  ngOnInit() {
    this.data.currentHelp.subscribe(help => this.help = help);
    
    this.upURL = this.url.app;
    this.role_id = this.svc_storage.get('user').role_id;
    this.components = this.svc_storage.get('components');

    setTimeout(() => { this.loadingIndicator = false; }, 1000);
  }

  ngAfterViewInit() {
    setTimeout(() => { 	this.data.changeHelp(helpData["default"])});
	}

  onClick() {
    this.spinner = true;

    let httpOptions = {
      headers: new HttpHeaders({
          'Content-Type': 'application/json'
      })
    }

    if(this.role_id != null){
      let data = {role_id: this.role_id, components: this.components};
      this.http.post(this.url.rest + '/tms/getAdvancedSearchEntriesWithComponentFiltering', data, httpOptions)
      .subscribe((data) => {
        this.result = (data);
        this.displayItems = this.result['entries'];
        this.spinner = false;
      }, error => {
        this.spinner = false;
        console.log(error);
        this.errorFromSubscribe = error;
      });
    }
    
  }
}
